import type { CSSProperties } from 'react';

import { DateTime } from 'luxon';

const MIN_WIDTH = 0.03;
const START_HOUR = 5;
const END_HOUR = 29;

const clamp = (min: number, value: number, max: number) => Math.min(max, Math.max(value, min));

const interpolateForShift = (when: string, tz: string, dayOffset: number) => {
  const dateTime = DateTime.fromISO(when, { zone: tz });
  const hourFloat = dateTime.hour + dateTime.minute / 60 + dayOffset * 24;
  const boundedHourFloat = clamp(START_HOUR, hourFloat, END_HOUR);
  const position = (boundedHourFloat - START_HOUR) / (END_HOUR - START_HOUR);
  return clamp(0, position, 1);
};

const formatPercentage = (value: number) => `${Math.round(value * 10000) / 100}%`;

export const shiftEntryStyle = (
  started: string,
  ended: string | undefined,
  tz: string,
  basisDate: string = started,
): CSSProperties => {
  const startDayOffset = DateTime.fromISO(started, { zone: tz })
    .startOf('day')
    .diff(DateTime.fromISO(basisDate, { zone: tz }).startOf('day'), 'days').days;
  const endDayOffset = ended
    ? DateTime.fromISO(ended, { zone: tz })
        .startOf('day')
        .diff(DateTime.fromISO(basisDate, { zone: tz }).startOf('day'), 'days').days
    : 0;

  const startBounds = started ? interpolateForShift(started, tz, startDayOffset) : 0;
  const endBounds = ended ? interpolateForShift(ended, tz, endDayOffset) : 1;
  let left: string | number = startBounds;
  const width = Math.max(endBounds - startBounds, MIN_WIDTH);
  let right: string | number = endBounds;

  if (right > 0.5) {
    left = 'auto';
    right = formatPercentage(1 - (right as number));
  } else {
    right = 'auto';
    left = formatPercentage(left as number);
  }

  return {
    left,
    width: formatPercentage(width),
    right,
  };
};
